/*eslint-disable*/
import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer";
import RefreshSession from "../@core/components/refresh-sesion";
import { useTranslation } from "react-i18next";
import "core-js/stable/atob";
import { jwtDecode } from "jwt-decode";
import { SESSION_TIMEOUT } from "../configs/environment";

export const IdleContext = createContext();

// Los tiempos dependen del entorno declarado en los .env (`ENVIROMENT`): en desarrollo la
// sesión dura horas para no interrumpir la depuración; en test y producción se mantienen los
// 240 s con aviso 60 s antes. Ver src/configs/environment.js.
const { timeout, promptBeforeIdle } = SESSION_TIMEOUT;

export const IdleProvider = ({ children }) => {
	// ** States
	const [status, setStatus] = useState("Active");
	const [open, setOpen] = useState(false);
	const [remaining, setRemaining] = useState(0);

	// ** Hooks
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate()

	const onIdle = () => {
		setStatus("Idle");
		setOpen(false);
		localStorage.removeItem("userInfo")
		localStorage.removeItem("userInfoTFA")
		localStorage.removeItem("userEmployee")
		localStorage.removeItem("tokenBP")
		navigate('/login')
	};

	const onActive = () => {
		setStatus("Active");
		setOpen(false);
	};

	const onPrompt = () => {
		setStatus("Prompted");
    
		if (location.pathname !== '/login') {
      		setOpen(true);
		}
	};

	const { getRemainingTime, activate } = useIdleTimer({
		onIdle,
		onActive,
		events: ["mousedown", "keypress"],
		onPrompt,
		timeout,
		promptBeforeIdle,
		throttle: 500,
	});

	useEffect(() => {
		const interval = setInterval(() => {
			setRemaining(Math.ceil(getRemainingTime() / 1000));
		}, 500);

		document.addEventListener('click', () => {
		  refreshToken()
		})

		return () => {
			clearInterval(interval);
		};
	}, []);

	const handleClose = () => {
		onIdle();
	};

	const handleStillHere = async () => {
		activate();
	};

  const refreshToken = () => {
    if (location.pathname === '/login') {
      return
    }
    const token = localStorage.getItem('tokenBP')

    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now() && status === 'Active') {
        handleStillHere()
      }
    }
  }

	return (
		<IdleContext.Provider
			value={{
				status,
				remaining,
				open,
				handleStillHere,
			}}
		>
			<div>
				{children}
				<RefreshSession 
          open={open} 
          toggleModal={handleClose} 
          remaining={remaining} 
          handleStillHere={handleStillHere} 
		  refreshToken={refreshToken}
          t={t} 
        />
			</div>
		</IdleContext.Provider>
	);
};

export const idleContext = () => {
	return useContext(IdleContext);
};
